module.exports = __webpack_public_path__ + "static/media/VCSS_Logo_f.0f5750da.png";